var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHumidityMid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00004 15.9167C5.15282 15.9167 3.5799 15.2778 2.28129 14C0.98268 12.7222 0.333374 11.1667 0.333374 9.33333C0.333374 8.45833 0.503513 7.62152 0.843791 6.82291C1.18407 6.0243 1.66671 5.31944 2.29171 4.70833L7.00004 0.0833282L11.7084 4.70833C12.3334 5.31944 12.816 6.0243 13.1563 6.82291C13.4966 7.62152 13.6667 8.45833 13.6667 9.33333C13.6667 11.1667 13.0174 12.7222 11.7188 14C10.4202 15.2778 8.84726 15.9167 7.00004 15.9167ZM2.00004 9.33333H12C12 8.68055 11.875 8.05902 11.625 7.46874C11.375 6.87847 11.0139 6.36111 10.5417 5.91666L7.00004 2.41666L3.45837 5.91666C2.98615 6.36111 2.62504 6.87847 2.37504 7.46874C2.12504 8.05902 2.00004 8.68055 2.00004 9.33333Z",
    fill: "#1A446F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumidityMid);
export default __webpack_public_path__ + "static/media/humidity_mid.f2f502be3dc3a9ee2475c580d2bb50b9.svg";
export { ForwardRef as ReactComponent };